export const CategoryList = [
    {
        id: 2,
        src: '/static/category/break.svg',
        content: 'Breakfast'
    },
    {
        id: 3,
        src: '/static/category/lunch.svg',
        content: 'Lunch'
    },
    {
        id: 4,
        src: '/static/category/snacks.svg',
        content: 'Snacks'
    },
    {
        id: 5,
        src: '/static/category/dinner.svg',
        content: 'Dinner'
    },
    {
        id: 1,
        src: '/static/category/supper.svg',
        content: 'Supper'
    },
]

export const DishesList = [
    {
        id: 1,
        src: '/static/dishes/dho.jfif',
        name: 'MN1',
        rating: 4,
        reviews: 454,
        price: '42.00'
    },
    {
        id: 2,
        src: '/static/dishes/dho.jfif',
        name: 'MN2',
        rating: 4,
        reviews: 454,
        price: '42.00'
    },
    {
        id: 3,
        src: '/static/dishes/dho.jfif',
        name: 'MN3',
        rating: 4,
        reviews: 454,
        price: '42.00'
    },
    {
        id: 4,
        src: '/static/dishes/dho.jfif',
        name: 'MN4',
        rating: 4,
        reviews: 454,
        price: '42.00'
    },
    {
        id: 5,
        src: '/static/dishes/dho.jfif',
        name: 'MN5',
        rating: 4,
        reviews: 454,
        price: '42.00'
    },
    {
        id: 6,
        src: '/static/dishes/dho.jfif',
        name: 'MN6',
        rating: 4,
        reviews: 454,
        price: '42.00'
    },
  ]

 export const slideBasicArrow = [
    {
      id: 2,
      srcImg: '/static/dishes/rice.avif',
      title: 'Slide Basic',
    },
    {
      id: 3,
      srcImg: '/static/dishes/rice.avif',
      title: 'Slide Basic',
    },
    {
      id: 4,
      srcImg: '/static/dishes/rice.avif',
      title: 'Slide Basic',
    },
    {
      id: 1,
      srcImg: '/static/dishes/rice.avif',
      title: 'Slide Basic',
    },
    {
      id: 5,
      srcImg: '/static/dishes/rice.avif',
      title: 'Slide Basic',
    },
  ]

export const GetRoutes = (type) => {
    const roles = {
        Admin: '/admin',
        Employee: '/user',
        FoodAdmin: '/foodVendor',
        ContractorAdmin: '/contractor',
        GuestAdmin: '/guest',
        KioskAdmin: '/kioskAdmin',
        CounterAdmin: '/swipe',
        FoodClerk: '/foodClerk',
        Intern: '/intern',
        SpecialGuest: '/specialGuest'
    }
    return roles[type]
}

export const companyDetails = {
    EmployeeCompanyName: "Caterpillar India Pvt Ltd",
    EmployeeCompanyAddress: " Division  Melnallathur, Thiruvallur, India  - 602 004 ",
    EmployeeCompanyGSTIN: "33AABCC4615K1ZW",
    SGSTPercent: 0.025,
    CGSTPercent: 0.025,
    CESSPercent: 0
}


export const WeekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday','Saturday', 'Sunday']


export const OVERALL_CAFETERIA_ID = 0

export const DROPDOWN_PLACEHOLDER_ID = 0

// tblMealType ("Select Type" in the menu item master / cutoff lunch) for a login role
const USER_TYPE_BY_ROLE = {
    ContractorAdmin: 1,
    Employee: 2,
    KioskAdmin: 3,
    GuestAdmin: 4,
}

export const userTypeOf = (roleName) => USER_TYPE_BY_ROLE[roleName] || null

export const S2V_OPTION = {
    id: 'S2V',
    name: 'S2V HOSPITALITY',
    address: 'A-13, 3rd Phase, SIDCO Industrial Estate, Guindy, Chennai, Tamil Nadu India- 600032',
    email: 'shanthosh.sivagnanam@gmail.com',
    phone: '+919150928222',
}

/*
  Annalakshmi's own details, from the client (BCP Pitstop - Annalakshmi.pptx, October 2026).
  The vendor master holds placeholders for this vendor ("Chennai", "999999999"), so these
  are shown instead, the same way S2V_OPTION is for S2V.
*/
export const ANNALAKSHMI_OPTION = {
    key: 'annalakshmi',
    name: 'Annalakshmi Restaurant P.Ltd',
    address: 'No.6, Mayor Ramanathan Salai, Spurtank Road, Chetpet, Chennai 600031',
    email: 'Annalakshmi_Chennai@yahoo.co.in',
    phone: '+916380109371',
}

export const isAnnalakshmiName = (name) => /annalakshmi|annalaksmi/i.test(`${name || ''}`)

/*
  Client request (October 2026): show Annalakshmi only - no vendor dropdown on the login
  footer, and About / Contact / Terms always show Annalakshmi's content. Set to true to bring
  back the dropdown and the per-vendor (S2V / Annalakshmi) pages.
*/
export const SHOW_VENDOR_PICKER = false

export const getVendorInfo = (vendor) => {
    if (!SHOW_VENDOR_PICKER) return { ...ANNALAKSHMI_OPTION }
    if (vendor && isAnnalakshmiName(vendor.name)) return { ...ANNALAKSHMI_OPTION }
    return {
        key: 's2v',
        name: (vendor && vendor.name) || S2V_OPTION.name,
        address: (vendor && vendor.address) || S2V_OPTION.address,
        email: (vendor && vendor.email) || S2V_OPTION.email,
        phone: (vendor && vendor.phone) || S2V_OPTION.phone,
    }
}